// src/redux/api/agencyApi.js
import { apiSlice } from ".";

export const agencyApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Accounts Dashboard
    getAccountsDashboard: builder.query({
      query: ({ agencyId, month, year }) =>
        `/Salary/GetAccountsDashboard?agencyid=${agencyId}&month=${month}&year=${year}`,
      // ❌ no transformation here, just return as is
      transformResponse: (res) => res,

      providesTags: ["AccountsDashboard"],
    }),
  }),
});

export const { useGetAccountsDashboardQuery } = agencyApi;
